<template>
  <JRow
    :class="{ 'pt-16': isMobile }"
    class="gap-y-16"
    spaceMd="12"
    spaceLg="12"
    spaceXl="12"
  >
    <JCol sm="6" md="6" lg="6" xl="6">
      <JRow class="input__label font-regular">
        {{ $t('profile.supplierType.label') }}
      </JRow>
      <JRow class="font-bold">
        {{
          $t(`profile.supplierTypes.${activeSupplierType?.title.toLowerCase()}`)
        }}
      </JRow>
    </JCol>
    <JCol sm="6" md="6" lg="6" xl="6">
      <JRow class="input__label font-regular">
        {{ $t('profile.supplierName.label') }}
      </JRow>
      <JRow class="font-bold">
        {{ loyaltyAccount?.supplierName ? loyaltyAccount.supplierName : '-' }}
      </JRow>
    </JCol>
    <JCol sm="6" md="6" lg="6" xl="6">
      <JRow class="input__label font-regular">
        {{ $t('profile.accountName.label') }}
      </JRow>
      <JRow class="font-bold">
        {{ loyaltyAccount?.accountName ? loyaltyAccount.accountName : '-' }}
      </JRow>
    </JCol>
    <JCol sm="6" md="6" lg="6" xl="6">
      <JRow class="input__label font-regular">
        {{ $t('profile.accountNumber.label') }}
      </JRow>
      <JRow class="font-bold">
        {{ loyaltyAccount?.accountNumber ? loyaltyAccount.accountNumber : '-' }}
      </JRow>
    </JCol>
    <JCol sm="6" md="6" lg="6" xl="6">
      <JRow class="input__label font-regular">
        {{ $t('profile.loyaltyAccount.fields.booking') }}
      </JRow>
      <JRow>
        <JIcon
          :name="
            loyaltyAccount?.includeInBooking
              ? 'check-circle-bold-2'
              : 'close-circle-outline'
          "
          :class="[
            loyaltyAccount?.includeInBooking ? 'text-success' : 'text-danger',
          ]"
        />
      </JRow>
    </JCol>
  </JRow>
</template>

<script setup lang="ts">
import { JCol, JIcon, JRow } from '@journey/ui-kit'
import type { Props } from './MyLoyaltyAccountPreview.types'
import { useDevicePlatform } from '@/modules/Core/composables'
import { usePrivateSupplierType } from '@/modules/Profile/composables/usePublicSupplierType'

defineProps<Props>()

const { activeSupplierType } = usePrivateSupplierType()

const { isMobile } = useDevicePlatform()
</script>
